// extracted by mini-css-extract-plugin
export default {"container":"TableTwoFragment_container__9dAsY","header":"TableTwoFragment_header__nEk+S"};